import { getPermissions } from "@/apis/getPermisions";

export const drawerNubisDocListItems = [
  {
    permission: "nubis_docs_user_manual_page",
    link: "/nubis-docs/users-manual",
    text: "usersManual",
    disabled: true
  },
  {
    permission: "nubis_docs_release_note_page",
    link: "/nubis-docs/release-note",
    text: "releaseNote",
    disabled: true
  },
  {
    permission: "nubis_docs_qa_page",
    link: "/nubis-docs/q-a",
    text: "qa",
    disabled: true
  }
];

export const drawerNubisDriveListItems = [
  // {
  //   permission: "file_brower_view",
  //   link: "/nubis-drive/admin-utility",
  //   text: "adminUtility",
  //   disabled: false
  // },
  {
    permission: "android_app_management_view",
    link: "/nubis-drive/android-app",
    text: "androidApp",
    disabled: false
  },
  {
    permission: "android_app_management_view",
    link: "/nubis-drive/windows-app",
    text: "windowsApp",
    disabled: false
  },
  {
    permission: "file_management_view",
    link: "/nubis-drive/file",
    text: "file",
    disabled: false
  },
  {
    permission: "file_brower_view",
    link: "/nubis-drive/file-browser",
    text: "fileBrowser",
    disabled: false
  },
  {
    permission: "share_with_me_view",
    link: "/nubis-drive/shared-with-me",
    text: "sharedWithMe",
    disabled: false
  }
];
// export const drawerGroupsListItems = [
//     {
//         permission: "device_group_mapping",
//         link: "/groups/groups-devices",
//         text: 'groups',
//         disabled: false
//     },
//     {
//         permission: "device_tag_mapping",
//         link: "/groups/tags",
//         text: 'tags',
//         disabled: false
//     },

// ]

export const drawerGroupsListItems = [
  {
    permission: "device_group_mapping",
    link: "/groups/groups-devices",
    text: "groups",
    disabled: false
  },
  {
    permission: "device_tag_mapping",
    link: "/groups/tags",
    text: "tags",
    disabled: false
  },
  // {
  //   permission: "account_group_mapping",
  //   link: "/groups/users",
  //   text: "user_groups",
  //   disabled: false
  // },
  {
    permission: "Device Command Status",
    link: "/groups/device-control-log",
    text: "device_control_log",
    disabled: false
  },
  // {
  //   permission: "",
  //   link: "/groups/device-log",
  //   text: "device_log",
  //   disabled: false
  // }
];

export function getHasPermissionEntry() {
  const config = [
    {
      permission: "DashBoard",
      link: "/"
    },
    {
      permission: "Device Monitoring",
      children: drawerGroupsListItems
    },
    {
      permission: "Alarm Management",
      link: "/alarm/templates"
    },
    {
      permission: "Schedule Task Management",
      link: "/schedule/templates"
    }
  ];

  const noPermissionConfig = [
    {
      link: "/power-management"
    }
  ];

  const finalConfig = [
    ...config,
    ...drawerNubisDriveListItems,
    ...noPermissionConfig
  ];

  const userPermisions = getPermissions();

  function getEntry(config) {
    for (const route of config) {
      if (userPermisions.includes(route.permission) || !route.permission) {
        if (!route.children) {
          return route.link;
        } else {
          const subPermission = getEntry(route.children);
          if (subPermission) {
            return subPermission;
          }
        }
      }
    }
  }

  return getEntry(finalConfig) || "/no-permission";
}
